module.exports = __webpack_public_path__ + "img/XinyueLi.ac6ffb30.jpg";